module.exports = __webpack_public_path__ + "img/canteen.ea21a5db.svg";